export const css = {
	root: '_3xobgQN5',
	copyright: '_2LSlrIEn',
	selector: '_2d15aTfL',
	privacypolicy: '_3wM2rxt_',
	disclaimer: '_1Ds3LTlT',
	' _key': 'ascm-theme/ascm/lcc-app/footer'
};

export default css;
